import { useAIAssistantForPage } from '@euler/app/components/ai/pageContext';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { DeliveryCheckContextProvider } from '@euler/app/flows/task/functions/task-detail/delivery-check/DeliveryCheckContext';
import { TaskTimeoutInfo } from '@euler/app/flows/task/types';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { DeliveryCheckSceneType } from '@euler/model/enum';
import { WiredDeliveryCheckScreenContent } from './components/WiredDeliveryCheckScreenContent';
import { WiredDeliveryCheckScreenContentForIpad } from './components/WiredDeliveryCheckScreenContent.iPad';

export const DeliveryCheckScreen = wrapNavigatorScreen(
  ({ timeoutInfo }: { timeoutInfo?: TaskTimeoutInfo }) => {
    const { taskNo } = useTaskContext();
    useAIAssistantForPage('delivery_check', { taskNo });
    const isMobile = useIsMobileLayout();
    if (isMobile) {
      return (
        <DeliveryCheckContextProvider
          sceneType={DeliveryCheckSceneType.CompletionCheck}
          timeoutInfo={timeoutInfo}
        >
          <WiredDeliveryCheckScreenContent />
        </DeliveryCheckContextProvider>
      );
    }
    return (
      <DeliveryCheckContextProvider
        sceneType={DeliveryCheckSceneType.CompletionCheck}
        timeoutInfo={timeoutInfo}
      >
        <WiredDeliveryCheckScreenContentForIpad />
      </DeliveryCheckContextProvider>
    );
  },
  { headerShown: false },
);
